import { render, staticRenderFns } from "./DoorDescription.vue?vue&type=template&id=5ee31cbb&scoped=true"
import script from "./DoorDescription.vue?vue&type=script&lang=ts"
export * from "./DoorDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee31cbb",
  null
  
)

export default component.exports